// extracted by mini-css-extract-plugin
module.exports = {"floatingLogos":"FloatingPartnerLogos_floatingLogos__FvjjT","logoItem":"FloatingPartnerLogos_logoItem___QIm1"};